import React from "react";

import { Link } from "react-router";

import connectToStores from "alt-utils/lib/connectToStores";
import UserStore from "../stores/UserStore";
import PassUtil from "../utils/PassUtil";

const SCANNER_SCRIPT_URL =
  "https://unpkg.com/html5-qrcode@2.3.4/html5-qrcode.min.js";

class CheckPass extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      foundPass: null
    };

    this.renderScanner = this.renderScanner.bind(this);
    this.onScan = this.onScan.bind(this);
  }
  static getStores() {
    return [UserStore];
  }

  static get contextTypes() {
    return {};
  }

  static getPropsFromStores() {
    return {};
  }

  componentDidMount() {
    if (!document.querySelector(`script[src="${SCANNER_SCRIPT_URL}"]`)) {
      var script = document.createElement("script");
      script.type = "text/javascript";
      script.src = SCANNER_SCRIPT_URL;
      script.onload = () => setTimeout(this.renderScanner, 250);
      document.body.appendChild(script);
    } else {
      this.renderScanner();
    }
  }

  componentWillReceiveProps(newProps) {}

  getStyles() {
    return {
      container: {
        padding: 10,
        textAlign: "center"
      },
      intro: {
        padding: 15,
        fontSize: "12pt",
        lineHeight: 1.5,
        color: "rgba(0,0,0,0.54)"
      }
    };
  }

  componentWillUnmount() {
    if (this.html5QrcodeScanner) {
      this.html5QrcodeScanner.stop();
      this.html5QrcodeScanner = null;
    }
  }

  renderScanner() {
    try {
      if (this.html5QrcodeScanner) {
        this.html5QrcodeScanner.stop();
        this.html5QrcodeScanner = null;
      }
      this.html5QrcodeScanner = new window.Html5Qrcode("CheckPassReader");
      const config = { fps: 10, qrbox: { width: 150, height: 150 } };
      this.html5QrcodeScanner.start(
        { facingMode: "environment" },
        config,
        this.onScan
      );
    } catch (e) {
      console.error(e);
    }
  }

  onScan(id) {
    if (id === this.state.id) return;

    this.setState({
      hasSearched: true,
      isSearching: true,
      id,
      foundPass: null,
      error: null
    });

    PassUtil.fetchOne(UserStore.getState().apiKey, id)
      .then(pass => {
        this.setState({ isSearching: false, foundPass: pass });
      })
      .catch(e => {
        this.setState({ isSearching: false, error: e.message });
      });
  }

  render() {
    const styles = this.getStyles();

    return (
      <div className="" style={styles.container}>
        <h1>Pass QR Code Lookup</h1>
        <div style={{ margin: "20px auto", fontSize: 16 }}>
          {this.state.isSearching ? (
            "Looking up pass..."
          ) : this.state.foundPass ? (
            <div>
              {this.state.foundPass.name} (
              {this.state.foundPass.pass_bucket.name}, owned by{" "}
              {this.state.foundPass.person.name}) &middot;{" "}
              <Link target="_blank" to={`/passes/${this.state.foundPass.id}`}>
                View pass
              </Link>
            </div>
          ) : this.state.hasSearched ? (
            "No pass found. Are you sure that's a pass QR code?"
          ) : (
            "Scan a pass QR code to look it up..."
          )}
        </div>
        {this.state.id ? (
          <div style={{ margin: "-15px auto 20px", fontSize: 12 }}>
            ID: {this.state.id}
          </div>
        ) : (
          ""
        )}
        <div>
          <div
            id="CheckPassReader"
            style={{
              width: "90%",
              maxWidth: 400,
              margin: "0 auto"
            }}
          ></div>
        </div>
      </div>
    );
  }
}

export default connectToStores(CheckPass);



// WEBPACK FOOTER //
// ./src/app/components/check-pass.jsx